<template>
  <v-app class="d-flex justify-center align-center">
    <MainMenu />
    <v-main>
      <router-view></router-view>
      <Snackbar 
        :show="snackbarState.show" 
        :color="snackbarState.color" 
        :message="snackbarState.message" 
        @update:show="snackbarState.show = false"
      />
    </v-main>
  </v-app>
</template>



<script setup>
import MainMenu from './components/MainMenu.vue';
import Snackbar from './components/Snackbar.vue';
import snackbarService from './services/snackbarService.js';

const snackbarState = snackbarService.getState();

</script>

<style>

.main-background {
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: linear-gradient(to bottom right, #009688, #B2DFDB);
}

.v-card {
  border-radius: 10px; /* Arrondit les coins de la carte */
  box-shadow: 0 4px 6px rgba(0,0,0,0.1); /* Ajoute une ombre pour un effet élévé */
}

.text-h5 {
  font-size: 1.5rem;
  font-weight: 500;
  color: #333; /* Couleur du texte */
}


</style>
